import { render, staticRenderFns } from "./MoleculeMenuTriggerUniverse.vue?vue&type=template&id=f2069a4a&"
import script from "./MoleculeMenuTriggerUniverse.vue?vue&type=script&lang=js&"
export * from "./MoleculeMenuTriggerUniverse.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeMenuTriggerUniverse.vue?vue&type=style&index=0&id=f2069a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
